<template>
  <el-header class="page-header__wrap">
    <div class="title">
      <!-- {{ $route.meta.parent }} -->
      <span style="color: #333">{{ $route.matched[0].meta.title }}</span>
      <span v-if="$route.matched[0].meta.title"> > </span>
      {{ $route.meta.title }}
    </div>
    <div class="refresh">
      <el-popover
        @show="getAiteList"
        placement="bottom"
        width="600"
        trigger="manual"
        popper-class="page-header-popover"
        v-model="popperVisible"
      >
        <div class="aite-class" :style="`height: ${mainViewHeight}px`">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-input
                v-model="aiTeForm.approval_no"
                placeholder="请输入审批编号"
                @keydown.enter.native="getAiteList"
                @clear="getAiteList"
                clearable
                style="width: 100%"
                size="mini"
                ><i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getAiteList"
                ></i
              ></el-input>
            </el-col>
            <el-col :span="8">
              <el-input
                v-model="aiTeForm.approval_name"
                placeholder="请输入流程名称"
                @keydown.enter.native="getAiteList"
                @clear="getAiteList"
                clearable
                style="width: 100%"
                size="mini"
                ><i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getAiteList"
                ></i
              ></el-input>
            </el-col>
            <el-col :span="8">
              <el-input
                v-model.trim="aiTeForm.content"
                placeholder="请输入流程内容"
                @keydown.enter.native="getAiteList"
                @clear="getAiteList"
                clearable
                size="mini"
                style="width: 100%"
                ><i
                  slot="suffix"
                  class="el-input__icon el-icon-search"
                  @click="getAiteList"
                ></i
              ></el-input>
            </el-col>
          </el-row>
          <div class="aite-class-main">
            <div v-for="(item, index) in aiteList" :key="index">
              <div class="flow-comment">
                <div>{{ item.flow_comment }}</div>
                <div class="squaer" v-if="!item.is_read"></div>
              </div>
              <div v-if="item.picture_arr && item.picture_arr.length > 0">
                <span class="n_t">图片：</span>
                <span @click="view_img(item.picture_arr)" class="simg_num"
                  >{{ item.picture_arr.length }}张</span
                >
              </div>
              <div
                v-if="item.file_arr && item.file_arr.length > 0"
                style="display: flex; flex: 1"
              >
                <span class="n_t">附件：</span>
                <div style="flex: 1">
                  <div
                    class="file_name"
                    v-for="(f, i) in item.file_arr"
                    :key="i"
                  >
                    <el-link
                      type="primary"
                      target="_blank"
                      @click="handlePreview(f)"
                      >{{ i + 1 }}: {{ f.name }}</el-link
                    >
                    <div>
                      <el-button
                        size="mini"
                        type="text"
                        @click="download(f.file, f.name)"
                        >下载</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div>
                {{ item.creator_name }}在<span   
                  class="simg_num2"
                  @click="hanldialogVisible(item.approval_id)"
                  >{{ item.employee_name }}提交的{{ item.type_name }}</span
                >提到你
              </div>
              <div>{{ item.create_time }}</div>
              <el-divider class="my-divider"></el-divider>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="page.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          >
          </el-pagination>
        </div>
        <el-badge
          v-show="showAIte()"
          :value="getHeaderAiteTotal"
          :hidden="!getHeaderAiteTotal"
          style="margin-right: 30px"
          slot="reference"
        >
          <div @click="viewAite" class="point">提到我的</div>
        </el-badge>
      </el-popover>
      <!-- 提到我 -->
      <el-button icon="el-icon-refresh" size="small" @click="handleRefresh"
        >刷新</el-button
      >
    </div>
    <el-image-viewer
      v-show="showViewer"
      :on-close="closeViewer"
      :url-list="previewImages"
    />
    <Dialog
      :show="dialogVisible"
      :isFooterShow="false"
      @update:show="toggleShow"
    >
      <div class="textdialog">
        <div class="dialog-main-header">
          <p class="dialog-main-title">审核流程</p>
          <div class="flex">
            <prints :dataInfo="dataInfo"></prints>
            <share :dataInfo="dataInfo"></share>
          </div>
        </div>
        <div
          v-if="!!dataInfo.approval_no"
          class="flowlist"
          style="user-select: text !important"
        >
          <div class="flex ai no">
            <div class="">
              <span class="label">审批编号：</span>
              <span>{{ dataInfo.approval_no }}</span>
            </div>
            <div class="time flex ai">
              <img
                class="ta"
                v-if="dataInfo.creator.picture"
                :src="dataInfo.creator.picture"
                fit="cover"
              />
              <div class="tan" v-else>
                {{
                  dataInfo.creator.name ? dataInfo.creator.name.slice(-1) : ""
                }}
              </div>
              <span class="tat"
                >{{ dataInfo.creator.name }}
                {{ dataInfo.create_time }} 发起</span
              >
            </div>
          </div>
          <div class="dataInfo">
            <div class="content">
              <div class="flex mb20">
                <div>
                  <span class="title">{{ dataInfo.approval_name }}</span>
                  <span :class="`status${dataInfo.status} status`">{{
                    toStr(
                      {
                        1: "审批中",
                        2: "已撤销",
                        3: "审批通过",
                        4: "审批拒绝",
                      },
                      dataInfo.status
                    )
                  }}</span>
                </div>
              </div>
              <formcontent :form_config="form_config"
                ><div>
                  <h3 class="mt20">审批流程</h3>
                  <flowList
                    :flow_list="flow_list"
                    :dataInfo="dataInfo"
                    :stepsActive="stepsActive"
                  ></flowList></div
              ></formcontent>
              <h3 class="mt20">
                审批流程<span class="aut" v-if="dataInfo.auto_pass == 1"
                  >(已启用自动去重)</span
                >
              </h3>
              <flowList
                :flow_list="flow_list"
                :dataInfo="dataInfo"
                :stepsActive="stepsActive"
              ></flowList>
            </div>
          </div>
        </div>
        <div class="index_footerWrap" style="text-align: right">
          <!-- 1:'审批中',2:'已撤销',3:'审批通过',4:'审批拒绝' -->
          <el-button plain @click="handturnOver" v-if="isflow">转交</el-button>
          <el-button plain @click="handsendBack" v-if="isflow">退回</el-button>
          <el-button plain @click="handleComment">评论</el-button>
          <el-button
            plain
            @click="handledeal(2, '拒绝')"
            type="primary"
            v-if="isflow && person_type != 6"
            >拒绝</el-button
          >
          <el-button
            type="primary"
            @click="handledeal(1, '同意')"
            v-if="isflow && person_type != 6"
            >同意</el-button
          >
          <el-button
            type="primary"
            @click="handledeal(1, '提交')"
            v-if="isflow && person_type == 6"
            >提交</el-button
          >
        </div>
      </div>
    </Dialog>
    <Comment ref="comment" @refresh="hanldialogVisible(aiteId)"></Comment>
    <SendBack ref="sendBack" @refresh="hanldialogVisible(aiteId)"></SendBack>
    <TurnOver ref="turnOver" @refresh="hanldialogVisible(aiteId)"></TurnOver>
    <Deal
      ref="deal"
      @refresh="hanldialogVisible(aiteId)"
      :status="status"
      :title="title"
    ></Deal>
    <!-- 预览文件 -->
    <VueOfficeView
      ref="fileView"
      :fileType="fileType"
      :fileUrl="fileUrl"
      :fileName="fileName"
    ></VueOfficeView>
  </el-header>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { mixinPreview } from "@/mixins/filepreview.js";
import VueOfficeView from "@/components/VueOfficeView.vue";
import { durationLabelComponent } from "@/views/approve/sponsor/components/const.js";
import Dialog from "@/TUIKit/components/common/Dialog/index.vue";
import formcontent from "@/components/formcontent.vue";
import flowList from "@/components/flowList.vue";
import prints from "@/components/print.vue";
import share from "@/components/share.vue";
import Comment from "@/components/Comment.vue";
import Deal from "@/components/deal.vue";
import SendBack from "@/components/sendBack.vue";
import TurnOver from "@/components/turnOver.vue";
export default {
  name: "PageHeader",
  mixins: [mixinPreview],
  components: {
    ElImageViewer,
    VueOfficeView,
    Dialog,
    formcontent,
    flowList,
    prints,
    share,
    Comment,
    Deal,
    SendBack,
    TurnOver,
  },

  data() {
    return {
      // 提到我列表数据
      popperVisible: false,
      aiteId: 0,
      status: 1,
      title: "",
      aiteList: [],
      showViewer: false,
      previewImages: [],
      page: {
        page: 1,
        count: 10,
        total: 0,
      },
      flow_list: [],
      person_type: 0,
      form_config: [],
      stepsActive: 1,
      dataInfo: {},
      isflow: false,
      dialogVisible: false,
      aiTeForm: {
        approval_no: "",
        approval_name: "",
        content: "",
      },
      mainViewHeight: 600, // 默认高度，将在mounted中更新
      //
    };
  },
  mounted() {
    // 组件挂载后更新 main-view 的高度
    this.$nextTick(() => {
      this.mainViewHeight = this.getMainViewHeight();
    });
  },
  methods: {
    //刷新;
    handleRefresh() {
      // window.location.reload();
      this.$router.go(0);
    },
    viewAite() {
      // 每次显示 popover 时更新高度
      this.mainViewHeight = this.getMainViewHeight();
      this.popperVisible = !this.popperVisible;
      this.$store.commit("setHeaderAite", !this.$store.state.showHeaderAite);
    },
    getAiteList() {
      this.$http
        .get("/admin/employeeApproval/atList", {
          params: {
            page: this.page.page,
            count: this.page.count,
            ...this.aiTeForm,
          },
        })
        .then((res) => {
          if (res.code == 1) {
            this.aiteList = res.data.list;
            // this.aiteList = [...this.aiteList, ...res.data.list]
            this.page.total = res.data.total;
          }
        });
    },
    view_img(view_img) {
      this.showViewer = true;
      this.previewImages = view_img;
    },
    closeViewer() {
      this.showViewer = false;
    },
    download(urls, name) {
      const option = {
        mode: "cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      // If the browser supports fetch, use blob to download, so as to avoid the browser clicking the a tag and jumping to the preview of the new page
      if (window?.fetch) {
        fetch(urls, option)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = name;
            a.click();
          });
      } else {
        const a = document.createElement("a");
        a.href = urls;
        a.target = "_blank";
        a.download = name;
        a.click();
      }
    },
    handleSizeChange(val) {
      this.page.page = 1;
      this.page.count = val;
      this.getAiteList();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getAiteList();
    },
    async hanldialogVisible(id) {
      this.aiteId = id;
      const res = await this.$http.get("/admin/employeeApproval/detail", {
        params: { id: id },
      });
      let flow = res.data.flow_list;
      this.flow_list = flow.map((item) => {
        let processor = item.processor
          ? item.processor
              .split(",")
              .filter((i) => i)
              .map((i) => i * 1)
          : "";
        return {
          ...item,
          employees:
            processor && item.person_type == 4
              ? item.employees.filter((v) => processor.indexOf(v.id) > -1)
              : item.employees,
        };
      });
      this.person_type =
        this.flow_list[res.data.cur_flow_level - 1].person_type;
      this.form_config = res.data.form_content.fields;
      //加入时长的显示
      let durationFieldRightIndex = this.form_config.findIndex(
        (i) => i.__config__.show_duration
      );
      if (durationFieldRightIndex > -1) {
        let durationObj = this.form_config[durationFieldRightIndex];
        let durationLabelComponent_ = durationLabelComponent;
        let danweiMap = {
          1: "小时",
          2: "天",
          3: "天",
        };
        let str = durationObj.__config__.duration;
        let danwei = danweiMap[durationObj.__config__.duration_type];
        let field = {
          ...durationLabelComponent_,
          __config__: {
            ...durationLabelComponent_.__config__,
            defaultValue: JSON.stringify(
              `${str}${danwei}` ? `${str}${danwei}` : ""
            ),
          },
        };
        this.form_config.splice(durationFieldRightIndex + 1, 0, field);
      }
      //
      console.log(this.form_config, "form_config.value");
      this.stepsActive = res.data.cur_flow_level;
      this.dataInfo = res.data;
      let userid = localStorage.getItem("userid");
      let cur_flow = this.dataInfo.cur_flow;
      let employees = cur_flow.employees ? cur_flow.employees : [];
      this.isflow = employees.some((item) => {
        return item.id == userid && item.is_processed !== 1;
      });
      this.dialogVisible = true;
    },
    toggleShow(val) {
      this.dialogVisible = val;
    },
    toStr(data, key) {
      return data[key];
    },
    handturnOver() {
      let id = this.dataInfo.flow_list.filter(
        (item) => item.flow_status == 1
      )[0].id;
      let dom = this.$refs.turnOver;
      dom?.toggle(true);
      dom?.getDetail(this.dataInfo, id);
      dom = null;
    },
    handsendBack() {
      let id = this.dataInfo.flow_list.filter(
        (item) => item.flow_status == 1
      )[0].id;
      let dom = this.$refs.sendBack;
      dom?.toggle(true);
      dom?.getDetail(this.dataInfo, id);
      dom = null;
    },
    handleComment() {
      let dom = this.$refs.comment;
      dom?.toggle(true);
      dom?.getDetail(this.dataInfo);
      dom = null;
    },
    handledeal(status1, title1) {
      let id = this.dataInfo.flow_list.filter(
        (item) => item.flow_status == 1
      )[0].id;
      this.status = status1;
      this.title = title1;
      let dom = this.$refs.deal;
      dom?.toggle(true);
      dom?.getDetail(this.dataInfo.value, id);
      dom = null;
    },
    // 获取 class 为 main-view 的元素高度
    getMainViewHeight() {
      const mainViewElement = document.querySelector(".main-view");
      if (mainViewElement) {
        // 返回元素的高度（包含内边距，不包含边框和外边距）
        const height = mainViewElement.clientHeight;
        console.log("main-view 元素高度:", height + "px");
        return height;
      } else {
        console.warn("未找到 class 为 main-view 的元素");
        return 0;
      }
    },
    showAIte() {
      const list = ["/approve/sponsor", "/approve/my", "/approve/copy"];
      return list.includes(this.$route.path);
    },
  },
  watch: {
    $route(to, from) {
      if(!this.showAIte()) {
        this.popperVisible = false;
      }
    },
  },
  computed: {
    getHeaderAiteTotal() {
      return this.$store.state.headerAiteTotal;
    },
  },
};
</script>
<style lang="scss" scoped>
.page-header__wrap {
  height: 50px !important;
}
.aite-class {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.aite-class-main {
  flex: 1;
  overflow: auto;
  > div {
    padding-top: 10px;
  }
}
.simg_num {
  color: #0476fc;
  cursor: pointer;
  text-decoration-line: underline;
}
.simg_num2 {
  color: #0476fc;
  cursor: pointer;
}
.file_name {
  display: flex;
  justify-content: space-between;
  flex: 1;
}
::v-deep .el-divider--horizontal {
  margin: 10px 0 !important;
}
::v-deep .el-popper {
  z-index: 2 !important;
}
::v-deep .page-header-popover {
  z-index: 2 !important;
}
.flow-comment {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 10px;
  .squaer {
    width: 10px;
    height: 10px;
    background-color: #f56c6c;
    border-radius: 50%;
  }
}
.textdialog {
  width: 900px;
}
.aut {
  font-size: 12px;
  color: #999;
  font-weight: 500;
}
</style>
<style lang="scss" scoped>
@import "@/TUIKit/assets/styles/common";

a {
  color: #679ce1;
}
.ai {
  align-items: center;
}
.custom {
  font-size: 14px;
  h1 {
    font-size: 14px;
    color: #000;
  }

  h1,
  a,
  p {
    font-size: 14px;
  }

  .evaluate {
    ul {
      display: flex;
      padding: 10px 0;
    }

    &-list {
      display: flex;
      flex-direction: row;

      &-item {
        padding: 0 2px;
      }
    }
  }

  .order {
    display: flex;

    main {
      padding-left: 5px;

      p {
        font-family: PingFangSC-Regular;
        width: 145px;
        line-height: 17px;
        font-size: 14px;
        color: #999;
        letter-spacing: 0;
        margin-bottom: 6px;
        word-break: break-word;
      }

      span {
        font-family: PingFangSC-Regular;
        line-height: 25px;
        color: #ff7201;
      }
    }

    img {
      width: 67px;
      height: 67px;
    }
  }
}
.approval_name {
  font-size: 16px;
  font-weight: 600;
}
.tips {
  color: #999;
  font-weight: 600;
}
.text {
  color: #0476fc;
  font-weight: 600;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.flex-row {
  display: flex;
}
.no {
  height: 50px;
  line-height: 50px;
  border-bottom: solid 1px #eee;
  font-weight: bold;
  font-size: 14px;
}
.label {
  color: #999;
}
.dataInfo {
  flex: 1;
  overflow-y: scroll;
}
.flowlist {
  padding: 20px 0 0;
  height: 700px;
  overflow: auto;
}
.content {
  padding: 30px 0;

  .title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .time {
    display: flex;
    align-items: center;
    color: #999;
  }
}
.mb20 {
  margin-bottom: 20px;
}
.content {
  padding: 30px 0;

  .title {
    margin-right: 20px;
    font-size: 16px;
    font-weight: bold;
  }
  .time {
    display: flex;
    align-items: center;
    color: #999;
  }
}
.ta {
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.tan {
  background: #0476fc;
  width: 32px;
  height: 32px;
  margin: 0 10px 0 0;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.tat {
  font-weight: 500;
  font-size: 12px;
}
.mt20 {
  margin-top: 20px;
}
.log {
  width: 500px;
  height: 80vh;
  overflow-y: scroll;
}
.right_t {
  height: 80px;
  background: #ffffff;
  border-bottom: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  position: sticky;
  top: 0;
  z-index: 2;
}
.right_ts {
  font-weight: bold;
  font-size: 16px;
  color: #333333;
}
.ddkey {
  line-height: 2;
}
.ddvalue {
  line-height: 2;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.look {
  height: 40px;
  background: #0476fc;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 4px;
  margin: 10px 0 0;
  cursor: pointer;
}
.index_footerWrap {
  padding: 10px 20px 10px;
  background: #fff;
}
.textDETAIL {
  width: 300px;
}
.textdialog {
  width: 900px;
}
.aut {
  font-size: 12px;
  color: #999;
  font-weight: 500;
}
::v-deep .page-header-popover {
  z-index: 2 !important;
}
</style>

<!-- 全局样式，专门用于设置这个页面的 popover z-index -->
<style lang="scss">
.page-header-popover {
  z-index: 2 !important;
}
.page-header-popover.el-popper {
  z-index: 2 !important;
}
.el-popper[x-placement^="bottom"].page-header-popover {
  z-index: 2 !important;
}
</style>
